module.exports = "<div class=\"container\">\r\n    <div>\r\n        <b>{{title}}</b>\r\n        <p>{{subtitle}}</p>\r\n    </div>\r\n    <div>\r\n        <button md-button (click)=\"closeDialogRef(true)\">Si, continua</button>\r\n        <button md-button (click)=\"closeDialogRef(false)\">No, annulla</button>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/dialog-close-asker/dialog-close-asker.component.html
// module id = ../../../../../src/app/components/dialog-close-asker/dialog-close-asker.component.html
// module chunks = main